import { useMemo } from 'react'
import { matchEquals } from 'Data/aggregate.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let patient = useMemo(() => {
    if (!props.source || !props.configuration[props.source]) return data

    return props.configuration[props.source]
  }, [data, props.configuration, props.source])

  let match = useMemo(
    () => ({
      firstName: matchEquals(
        props.configuration.internal?.firstName,
        props.configuration.external.firstName
      ),
      lastName: matchEquals(
        props.configuration.internal?.lastName,
        props.configuration.external.lastName
      ),
      gender: matchEquals(
        props.configuration.internal?.gender,
        props.configuration.external.gender
      ),
      birthDate: matchEquals(
        props.configuration.internal?.birthDate,
        props.configuration.external.birthDate
      ),
      phone: matchEquals(
        props.configuration.internal?.phone,
        props.configuration.external.phone
      ),
      email: matchEquals(
        props.configuration.internal?.email,
        props.configuration.external.email
      ),
      zip: matchEquals(
        props.configuration.internal?.zip,
        props.configuration.external.zip
      ),
      humanId: matchEquals(
        props.configuration.internal?.humanId,
        props.configuration.external.humanId
      ),
    }),
    [
      props.configuration.external.birthDate,
      props.configuration.external.email,
      props.configuration.external.firstName,
      props.configuration.external.gender,
      props.configuration.external.humanId,
      props.configuration.external.lastName,
      props.configuration.external.phone,
      props.configuration.external.zip,
      props.configuration.internal?.birthDate,
      props.configuration.internal?.email,
      props.configuration.internal?.firstName,
      props.configuration.internal?.gender,
      props.configuration.internal?.humanId,
      props.configuration.internal?.lastName,
      props.configuration.internal?.phone,
      props.configuration.internal?.zip,
    ]
  )

  return useMemo(() => {
    return {
      id: props.configuration.id,
      selected: props.configuration.selected,
      type: props.configuration.type,
      patient,
      internal: props.source === 'internal',
      match,
      error: props.error,
    }
  }, [
    props.configuration.id,
    props.configuration.selected,
    props.configuration.type,
    props.source,
    props.error,
    patient,
    match,
  ])
}
